import { Grid, IconButton, Popper } from '@material-ui/core';
import styled from 'styled-components';
import { bktProducts } from './constant';

const StyledPopper = styled(Popper)`
  z-index: 10000;
  padding: 0;
  border-radius: 32px;

  width: 370px;
  max-width: calc(100vw - 16px);

  background: #ebeef6;
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
  overflow: hidden;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #ebeef6;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #cacdd3;
    border-radius: 4px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #babcc2;
  }

  ::-webkit-scrollbar-button {
    background: #ebeef6;
    height: 28px;
    width: 16px;
    border-radius: 4px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-button:hover {
    background: #d4530c;
  }

  scroll-behavior: smooth;
`;

const Container = styled.div`
  padding: 8px;
  padding-right: 0;
  background: #fff;
  border-radius: 32px;
  box-shadow: inset 0 0 0 8px #ebeef6;

  height: 510px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
`;

const Content = styled.div`
  background: #fff;
  border-radius: 32px;
  width: 100%;
  padding: 16px;
`;

const Wrapper = styled.a`
  text-decoration: none;
  color: inherit;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;

const AppButton = styled(IconButton)`
  width: 100%;
  height: auto;
  min-height: 100px;
  border-radius: 8px !important;
  padding: 4px !important;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start !important;

  img {
    width: 52px;
    height: 52px;
  }

  .MuiIconButton-label {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
  }
`;

const AppName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #183459;

  display: block;
  width: 100%;
  max-width: 100px;

  text-align: center;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 20px;
  min-width: 100%;

  &.smaller {
    max-width: 80px;
  }
`;

const WrapperNoLink = styled.div`
  color: inherit;

  display: flex;
  align-items: center;
  justify-content: center;

  pointer-events: none;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;

const content = (
  <Content>
    <Grid container spacing={1}>
      {bktProducts.map((app) => (
        <Grid item xs={4} key={app.id}>
          {app?.link ? (
            <Wrapper href={app.link} target="_blank" rel="noopener noreferrer">
              <AppButton title={app.title}>
                <img src={app.img} alt={app.title} />
                <AppName>{app.title}</AppName>
              </AppButton>
            </Wrapper>
          ) : (
            <WrapperNoLink>
              <AppButton>
                <img src={app.img} alt={app.title} />
                <AppName>{app.title}</AppName>
              </AppButton>
            </WrapperNoLink>
          )}
        </Grid>
      ))}
    </Grid>
  </Content>
);

function AppsDropdown({ anchorEl }) {
  return (
    <div className="apps-dropdown">
      <StyledPopper
        open
        anchorEl={anchorEl}
        placement="bottom"
        onClick={(e) => e.stopPropagation()}>
        <Container>{content}</Container>
      </StyledPopper>
    </div>
  );
}

export default AppsDropdown;
